import React from "react";
import { Switch, Route, Redirect } from "react-router";

import { clientUrls } from "misc/urls";

import CddaOverviewComponent from "../components/CddaOverviewComponent";
import CddaDriversLogComponent from "../components/CddaDriversLogComponent";
import CddaFleetConfigurationComponent from "../components/CddaFleetConfigurationComponent";
import CddaDefectTicketsComponent from "../components/CddaDefectTicketsComponent";

const CddaContainer = () => {
    return (
        <Switch>
            <Route exact path={clientUrls.modules.cdda.overview()}>
                <CddaOverviewComponent />
            </Route>

            <Route exact path={clientUrls.modules.cdda.fleetConfiguration()}>
                <CddaFleetConfigurationComponent />
            </Route>

            <Route exact path={clientUrls.modules.cdda.driversLog()}>
                <CddaDriversLogComponent />
            </Route>

            <Route exact path={clientUrls.modules.cdda.defectTickets()}>
                <CddaDefectTicketsComponent />
            </Route>

            <Redirect to={clientUrls.modules.cdda.overview()} />
        </Switch>
    );
};

export default CddaContainer;
